import React, { Component, Fragment } from 'react';
import MetaTags from "react-meta-tags";
import Header from '../layouts/Header';
import Breadcrumb from '../layouts/Breadcrumbs';
import Instafeeds from '../layouts/Instafeeds';
import Footer from '../layouts/Footertwo';
import Content from '../sections/about/Content';

class About extends Component {
    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>Joyería Bacelis</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header logoOnly/>
                <div className="breadcrumb-bacelis">
                    <Breadcrumb breadcrumb={{ pagename: 'Joyería Bacelis' }} hideTrail />
                </div>
                <Content/>
                <Instafeeds/>
                <Footer/>
            </Fragment>
        );
    }
}

export default About;
